import React from 'react'
import { connect } from 'react-redux'
import {showBackToSchoolModal} from '../actions/backToSchoolModal'
import {getUserSegment} from '../utils/getUserSegment'


//Logic

// ActiveMonthly and ChurnedPro see back to school modal
//Users with no history see 'Getting Started'

//Users on free plan who are not shown 'Getting Started' see 'Upgrade'



class ContextBadge extends React.Component{


	constructor(){
		super()		
		this.shouldDisplayUpgradeButton=this.shouldDisplayUpgradeButton.bind(this)
		this.buttonToDisplay=this.buttonToDisplay.bind(this)
		this.shouldDisplayGettingStartedButton=this.shouldDisplayGettingStartedButton.bind(this)
		this.shouldDisplayUpgradeButton=this.shouldDisplayUpgradeButton.bind(this)
		this.shouldDisplayBackToSchoolButton=this.shouldDisplayBackToSchoolButton.bind(this)
		this.showBackToSchoolModal=this.showBackToSchoolModal.bind(this)


		let isDiscountPeriod=false
		const discountPeriodStartDate = process.env.REACT_APP_DEFAULT_COUPON_START_DATE
		const discountPeriodEndDate = process.env.REACT_APP_DEFAULT_COUPON_END_DATE
		const currentDate = new Date()
		const startDate = new Date(discountPeriodStartDate)
		const endDate = new Date(discountPeriodEndDate)

		if(startDate<currentDate && endDate > currentDate){
		   isDiscountPeriod=true
		} 

		this.state={
			isDiscountPeriod:isDiscountPeriod
		}

	}


	showUpgrade(){
		window.location.hash='upgrade'
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'defaultUpgrade'
			})
		}
	}

	showGettingStartedGuide(){
		const win = window.open('https://help.plickers.com/hc/en-us/articles/360008947934-Getting-Started-Guide', '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'gettingStartedGuide'
			})
		}
	}




	showBackToSchoolModal(userSegment){
		this.props.showBackToSchoolModal(true)
		let type=''
		if(userSegment==='free'){
			type='BTS2019-Free'
		}else if(userSegment==='churnedPro'){
			type='BTS2019-ChurnedPro'
		}else if(userSegment==='activeMonthlyPro'){
			type='BTS2019-ActiveMonthlyPro'
		}else if(userSegment==='activeYearlyProNo2019Coupon'){
			type='BTS2019-ActiveYearlyPro'
		}
		
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:type
			})
		}



	}




	shouldDisplayGettingStartedButton(){
		let shouldDisplay=true
		if(this.props.historySetPolls.length >0 || this.props.historyQuestionPolls.length>0){
			shouldDisplay=false
		}
		return shouldDisplay
	}


	shouldDisplayUpgradeButton(){
		return this.props.service.product==='free'
	}


	shouldDisplayBackToSchoolButton(){
		const {isDiscountPeriod}=this.state
		const {backToSchoolModal}=this.props
		if(!isDiscountPeriod){
			return false
		}else if(backToSchoolModal && backToSchoolModal.permenantlyDismissed){
			return false
		}else{
			const userSegment = getUserSegment()
			if(userSegment==='churnedPro' || userSegment==='activeMonthlyPro'){
				return true
			}
			else return false
		}

		
	}



	buttonToDisplay(){

		const showPaymentFailure = false

		let badgeType=null
		if(this.props.historySetPolls && this.props.historyQuestionPolls && this.props.meta && this.props.service){
			
			if(this.shouldDisplayBackToSchoolButton()){
				badgeType='backToSchool'
			}

			else if(this.shouldDisplayGettingStartedButton()){
				badgeType='gettingStarted'
			}
			else if(this.shouldDisplayUpgradeButton()){
				badgeType='upgrade'
			}else if(showPaymentFailure){
				badgeType='paymentFailure'
			}
		}
		return badgeType
	}


	render(){	
		const button=this.buttonToDisplay()
		const showCardDiscountJan2019 = false
		const {isDiscountPeriod}=this.state
		const userSegment = getUserSegment()

		if(showCardDiscountJan2019){
			return(		
				<a data-tooltip='New all-plastic cards coming soon!' className='contextBadge tooltip tooltip--label' target='_blank' rel='noopener noreferrer' href='https://www.amazon.com/Plickers-Student-Cards-Set-40/dp/B00FPIQB3W'>					
					Laminated cards now 25% off ($14.99)
				</a>
			)
		}
		else if(button==='gettingStarted'){
			return(		
				<div className='contextBadge' onClick={()=>{this.showGettingStartedGuide()}}>
					Getting Started Guide
				</div>			
			)
		}else if(button==='upgrade'){
			return(		
				<div className='contextBadge' onClick={this.showUpgrade}>
					{isDiscountPeriod?'Save 45% on Plickers Pro':'Upgrade to Pro'}
				</div>			
			)
		}
		else if(button==='paymentFailure'){
			return(		
				<div className='contextBadge contextBadge--error' onClick={this.showUpgrade}>
					Payment Problem
				</div>			
			)
		}
		else if(button==='backToSchool'){
			return(		
				<div className='contextBadge' onClick={()=>{this.showBackToSchoolModal(userSegment)}}>
					{userSegment==='churnedPro'?'Get Coupon and Save 45%':'Save 45% on your Plickers Pro'}
				</div>			
			)
		}
		else return null
	}
}


export default connect(
	(state) => ({
		meta:state.meta,
		historySetPolls:state.historySetPolls,
		historyQuestionPolls:state.historyQuestionPolls,
		service:state.service,
		backToSchoolModal:state.backToSchoolModal,

	
	}),
	{ showBackToSchoolModal}
)(ContextBadge)



// WEBPACK FOOTER //
// ./src/components/ContextBadge.js